import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const tomos = [{
  icon: '📘',
  number: 'Tomo 1',
  title: 'Fundamentos de Bromatología, Composición y Clasificación de los Alimentos',
  subtitle: 'La base que tus alumnos necesitan para entender todo lo demás',
  problem: 'El primer contacto con la bromatología puede despertar curiosidad genuina o apagar el interés para siempre. Este tomo convierte conceptos técnicos en algo comprensible, relevante y conectado con los alimentos que tus alumnos consumen todos los días.',
  bullets: ['Definición de bromatología, historia y ramas de la disciplina', 'El Codex Alimentarius y su aplicación real en América Latina', 'Composición nutricional de los alimentos: agua, proteínas, lípidos, carbohidratos', 'Vitaminas, minerales y fibra dietaria explicados con claridad', 'Clasificación de alimentos y lectura crítica del etiquetado nutricional', 'Ejemplos con alimentos regionales de cada país'],
  result: 'Tus alumnos entienden qué estudia la bromatología, para qué sirve y cómo se conecta con su vida cotidiana y su formación técnica — desde la primera clase.'
}, {
  icon: '🦠',
  number: 'Tomo 2',
  title: 'Microbiología Alimentaria Aplicada al Aula',
  subtitle: 'El módulo más temido, ahora explicado con casos reales y actividades listas',
  problem: 'La microbiología es el tema que más intimidida a los alumnos — y a muchos docentes — porque mezcla biología, química y situaciones de riesgo real. Este tomo lo hace manejable, concreto y aplicable desde el taller escolar.',
  bullets: ['Microorganismos en los alimentos: bacterias, hongos, levaduras, virus y parásitos', 'Bacterias patógenas prioritarias: Salmonella, E. coli, Listeria, Staphylococcus y más', 'Micotoxinas: aflatoxinas en maní y maíz, fumonisinas, ocratoxina — con datos de LATAM', 'Factores de crecimiento microbiano: temperatura, pH, actividad de agua, Aw', 'Casos reales de Enfermedades Transmitidas por Alimentos (ETA) documentados en la región', 'Cómo explicar el concepto de carga microbiana sin laboratorio sofisticado'],
  result: 'Tus alumnos comprenden por qué los alimentos se contaminan, qué organismos intervienen y cómo actuar para prevenirlo — con ejemplos de su propio país.'
}, {
  icon: '✅',
  number: 'Tomo 3',
  title: 'Control de Calidad, Inocuidad Alimentaria, BPM y HACCP',
  subtitle: 'El núcleo técnico de la formación — completamente desarrollado para el taller escolar',
  problem: 'HACCP y BPM son los temas que más preguntan las empresas cuando contratan técnicos — y los que más confusión generan en el aula porque los materiales disponibles están pensados para industrias, no para escuelas. Este tomo los lleva al taller sin perder rigor.',
  bullets: ['Calidad e inocuidad alimentaria: diferencias, conceptos y aplicación práctica', 'Buenas Prácticas de Manufactura (BPM) adaptadas al taller escolar paso a paso', 'Implementación del sistema HACCP en procesos simples del aula', 'Identificación de puntos críticos de control en elaboraciones escolares', 'Normativa vigente en Argentina, Chile, Colombia, México, Perú, Ecuador, Bolivia y más países', 'Registros y documentación básica que un técnico debe conocer'],
  result: 'Tus alumnos no solo conocen HACCP y BPM — aprenden a aplicarlos en el taller con los recursos que tienen disponibles, y entienden por qué son exigidos en cualquier establecimiento de alimentos.',
  popular: true
}, {
  icon: '🔬',
  number: 'Tomo 4',
  title: 'Análisis Bromatológico, Contaminantes, Adulteración y Conservación',
  subtitle: 'El cierre técnico que completa la formación del técnico alimentario',
  problem: 'Este tomo une todo lo anterior con las herramientas analíticas reales. Tus alumnos aprenden a analizar, detectar problemas y conservar alimentos con fundamento técnico — no solo intuitivamente.',
  bullets: ['Métodos analíticos básicos: fisicoquímicos, microbiológicos y sensoriales', 'Análisis sensorial aplicado al taller: cómo enseñarlo con recursos simples', 'Contaminantes químicos en alimentos: metales pesados, plaguicidas, aditivos no declarados', 'Detección de fraude y adulteración alimentaria con ejemplos documentados en la región', 'Métodos de conservación: físicos, químicos y biológicos explicados con rigor técnico', 'Normativa aplicada al análisis y la conservación en distintos países de LATAM'],
  result: 'Tus alumnos cierran el año con una visión completa: saben analizar un alimento, detectar irregularidades y aplicar métodos de conservación fundamentados — las competencias que las empresas y los organismos de control más valoran.'
}];
export function TomosSection() {
  return <section className="py-24 px-4 bg-black" data-id="element-292">
      <div className="max-w-6xl mx-auto" data-id="element-293">
        <div className="text-center mb-16" data-id="element-294">
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-4" data-id="element-295">
            📘 Los 4 tomos del Mega Pack
          </h2>
          <p className="text-xl text-gold-light" data-id="element-296">
            Material completo para el aula
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-297">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          y: -5
        }} className={`bg-dark-card rounded-2xl border ${tomo.popular ? 'border-gold shadow-[0_0_30px_rgba(212,175,55,0.15)]' : 'border-dark-border'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-298">
              {tomo.popular && <div className="absolute top-6 right-[-35px] bg-gold text-black font-bold text-xs py-1 px-10 rotate-45 shadow-lg" data-id="element-299">
                  EL MÁS POPULAR
                </div>}

              <div className="flex items-center gap-4 mb-6" data-id="element-300">
                <span className="text-4xl" data-id="element-301">{tomo.icon}</span>
                <div data-id="element-302">
                  <div className="text-gold font-bold text-sm uppercase tracking-wider" data-id="element-303">
                    {tomo.number}
                  </div>
                  <h3 className="text-2xl font-serif font-bold leading-tight mt-1" data-id="element-304">
                    {tomo.title}
                  </h3>
                </div>
              </div>

              <p className="text-white font-medium mb-6 italic border-l-2 border-gold/50 pl-4" data-id="element-305">
                {tomo.subtitle}
              </p>

              <div className="mb-6" data-id="element-306">
                <h4 className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-2" data-id="element-307">
                  ¿Qué resuelve en el aula?
                </h4>
                <p className="text-gray-300 text-sm leading-relaxed" data-id="element-308">
                  {tomo.problem}
                </p>
              </div>

              <ul className="space-y-3 mb-8 flex-grow" data-id="element-309">
                {tomo.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-310">
                    <CheckCircle2 size={18} className="text-gold shrink-0 mt-0.5" data-id="element-311" />
                    <span className="text-gray-200 text-sm" data-id="element-312">{bullet}</span>
                  </li>)}
              </ul>

              <div className="bg-gold/10 border border-gold/30 rounded-xl p-4 mt-auto" data-id="element-313">
                <span className="text-gold font-bold block mb-1" data-id="element-314">
                  Resultado:
                </span>
                <p className="text-white text-sm" data-id="element-315">{tomo.result}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}